import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { getPosts } from '../services/blogService';
import { formatDateTime } from '../utils/formatters';
import { useSettings } from '../context/SettingsContext';

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [activeCategory, setActiveCategory] = useState('الكل');
  const [loading, setLoading] = useState(true);
  const { settings } = useSettings();

  useEffect(() => {
    const fetchPosts = async () => {
      const fetchedPosts = await getPosts();
      setPosts(fetchedPosts);
      setLoading(false);
    };
    fetchPosts();
  }, []);

  const categories = ['الكل', ...new Set(posts.map(p => p.category).filter(Boolean))];

  const filteredPosts = activeCategory === 'الكل' 
    ? posts 
    : posts.filter(post => post.category === activeCategory);

  // Helper to strip HTML for excerpt
  const stripHtml = (html) => {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  return (
    <div className="blog-page fade-in">
      <Helmet>
        <title>المدونة | {settings?.siteTitle || 'أسعار الذهب'}</title>
      </Helmet>
      <header className="page-header">
        <h1 className="page-title">مدونة أسعار الذهب</h1>
        <p className="page-subtitle">آخر المقالات والتحليلات لسوق الذهب</p>
      </header>

      <div className="container">
        {loading ? (
          <div className="loading-container"><p>جاري جلب المقالات...</p></div>
        ) : (
          <>
            {posts.length > 0 && categories.length > 1 && (
              <div className="category-filters">
                {categories.map(cat => (
                  <button 
                    key={cat} 
                    className={`category-btn ${activeCategory === cat ? 'active' : ''}`}
                    onClick={() => setActiveCategory(cat)}
                  >
                    {cat}
                  </button>
                ))}
              </div>
            )}

        {filteredPosts.length === 0 ? (
          <div className="empty-blog">
            <p>لا توجد مقالات حالياً في هذا القسم.</p>
          </div>
        ) : (
          <div className="blog-grid">
            {filteredPosts.map((post) => (
              <article key={post.id} className="blog-card">
                {post.coverImage && (
                  <div className="blog-card-image" style={{ backgroundImage: `url(${post.coverImage})` }}>
                    {post.category && <span className="blog-card-badge">{post.category}</span>}
                  </div>
                )}
                <div className="blog-card-content">
                  <div className="blog-meta">
                    <span className="blog-date">{formatDateTime(post.date)}</span>
                    <span className="blog-author-tag">بواسطة: {post.author || 'أسعار الذهب'}</span>
                  </div>
                  <h2 className="blog-title">{post.title}</h2>
                  <p className="blog-excerpt">{stripHtml(post.content).substring(0, 120)}...</p>
                  <Link to={`/post/${post.slug || post.id}`} className="read-more-btn">اقرأ المزيد</Link>
                </div>
              </article>
            ))}
          </div>
        )}
          </>
        )}
      </div>
    </div>
  );
};

export default Blog;

